import React, { useEffect, useRef, useState } from "react";

import Form from "../../../../../../components/Form";
import { useUser } from "../../../../../../store/user/selectors";

import { IProps } from "./interfaces";
import { Wrapper, MessageInput, Close } from "./styles";

const CreateMessage = ({ deleteChannel, channel, sendMessage }: IProps) => {
    const inputRef = useRef(null);
    const user = useUser();
    const [message, setMessage] = useState("");
    const [isFetching, setIsFetching] = useState(false);
    useEffect(() => {
        inputRef.current.addEventListener("keypress", e => {
            if (e.which === 13 && !e.shiftKey) {
                handleSendMessage();
                e.preventDefault();
            }
        });
    }, []);
    const changeMessage = ({ target: { value } }) => setMessage(value);
    const handleSendMessage = async () => {
        if (!message) return;
        setIsFetching(true);
        const { success } = await sendMessage(message);
        setIsFetching(false);
        setMessage(success ? "" : message)
    };
    return (
        <Wrapper>
            <div style={{ flex: 1 }}>
                <Form disabled={isFetching}>
                    <div style={{ display: "flex" }}>
                        <MessageInput ref={inputRef} value={message} onChange={changeMessage} />
                        <button onClick={handleSendMessage} className="button" style={{ marginBottom: 0 }}>
                            Send
                        </button>
                    </div>
                </Form>
            </div>
            {channel.creator === user._id && (
                <Close title="Delete channel" onClick={deleteChannel}>
                    ×
                </Close>
            )}
        </Wrapper>
    );
}

export default CreateMessage;
